export const metaReducers = [];
export const devModules = [];
export const environment = {
  target: 'prod',
  apiUrl: '',
  production: true,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  version: process.env.NX_PUBLIC_APP_VERSION,
};
export const zonePendingTasks = () => {
  /* Unused in production */
};
